import { useNavigate, useLocation } from "react-router-dom";
import { getCookie } from "../../utils/cookies";

export const usePreserveStoreIdNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (to, options = {}) => {
    
    const params = new URLSearchParams(location.search);
    let storeId = params.get("store_id") || params.get("storeId");

    if (storeId) {
      const hasQuery = typeof to === "string" && to.includes("?");
      const separator = hasQuery ? "&" : "?";
      navigate(`${to}${separator}store_id=${storeId}`, options);
    } else {
      navigate(to, options);
    }
  };
};
